"use strict";



/*****************
 ** WEBPACK FOOTER
 ** ./~/typestyle/lib/types.js
 ** module id = 380
 ** module chunks = 0
 **/